import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const MetaDelivery: ITypeSpecificPolicy<types.MetaDelivery> = {
  fields: {
    createdAt: dateTimeFieldPolicy(),
    receivedDate: dateTimeFieldPolicy()

  }
};
